import { createContext, useContext, PropsWithChildren } from 'react';

interface PDPContextValues {
  id: number;
  store: string;
}

const PDPContext = createContext<PDPContextValues>(
  {} as unknown as PDPContextValues,
);

export function usePDPContext() {
  return useContext(PDPContext);
}

export function PDPProvider({
  children,
  ...data
}: PropsWithChildren<PDPContextValues>) {
  return <PDPContext.Provider value={data}>{children}</PDPContext.Provider>;
}
